module.exports = __webpack_public_path__ + "static/media/footer-background-png-6.2c301edb.png";